<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch24"></a><a id="page_25"></a><a href="#/contents#ch24"><b>Around the World</b></a></h2>
<p class="noindent"><span>Thirteen percent of the world’s population lives in deserts.</span></p>
<p class="noindent"><span>World’s largest urban national park: Golden Gate National Recreation Area (74,820 acres).</span></p>
<p class="noindent"><span>Fifty-one countries were involved in World War II, the most of any war in human history.</span></p>
<p class="noindent"><span>Sweetwater, Texas, boasts the world’s largest rattlesnake roundup. The annual festival began in 1958 as a way for local farmers to get rid of rattlesnakes on their property. In the years since, it’s grown to include a parade, a snake-charmer competition, and a cook-off. (And they still collect snakes. More than 120 tons’ worth have been caught over the years.)</span></p>
<p class="noindent"><span>More people have seen magician David Copperfield perform live than any other entertainer in the world.</span></p>
<p class="noindent"><span>The <i>Saturday Night Fever</i> soundtrack has sold more than 30 million copies worldwide.</span></p>
<p class="noindent"><span>World’s biggest army: China’s People’s Liberation Army, with 2.2 million active troops.</span></p>
<p class="noindent"><span>Since 1495, the world has never seen 25 consecutive years without at least one war.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter24.vue?637d74e1